// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__fontSangBleuSunriseLivre_d1518c', '__fontSangBleuSunriseLivre_Fallback_d1518c'","fontWeight":400,"fontStyle":"normal"},"className":"__className_d1518c"};